import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Bitrix24Form } from "react-bitrix24-form";
import "./FormSection.css";

export default function FormSection(props) {
  return (
    <Container>
      <Row>
        <Col style={{ display: props.noLine }} className="form-first-col">
          {props.titleIcon}
          {props.titleContent}
        </Col>
      </Row>
      <Row>
        <Col className="form-second-col">
          {props.subTitleContent}
          {props.textContent}
        </Col>
        <Col className="form-third-col">
          <Bitrix24Form src={props.formSrc} data={props.formData} />
        </Col>
      </Row>
    </Container>
  );
}
